export default __webpack_public_path__ + "static/media/react-logo.6ce24c58.svg";